/**
 * @file predecessors.tab.tsx
 * @description Вкладка предшествующих задач для формы задачи.
 * Отображает таблицу зависимостей задачи от других задач с возможностью 
 * добавления новых и удаления существующих зависимостей.
 * Показывает статус, наименование, даты начала и окончания, а также ответственного за каждую предшествующую задачу.
 * @author AI Assistant
 * @created 2025-09-03
 * @updated 2025-09-03
 * @dependencies [react, @src/types, @components/form-controls/table, @utils/table-view, @components/icons/trash-flat, @src/utils/date-time-helper]
 * @related-files [@components/form-controls/table/table.component.tsx, @utils/table-view.tsx, @utils/date-time-helper.ts]
 */

import { tabProps } from '@src/types';
import { Table } from '@components/form-controls/table';
import { getDefaultCell, getBadgeCell } from '@utils/table-view';
import { TrashFlatIcon } from '@components/icons/trash-flat';
import { formatTimestamp } from '@src/utils/date-time-helper';
import { IColumnConfig } from '../../../types/pages';

export const Predecessors = ({ control, data }: tabProps) => {
    return (
        <Table
            columns={columns}
            addItemType="catalog"
            type={data?.item?.$type || ''}
            name="predecessors"
            control={control}
            hideHeader={true}
            isCanAddRows={true}
            isRowClickable={true}
            contextMenuItemList={contextMenuItemList}
            excludeIds={data?.item?.id ? [{ $item: data.item }] : []}
            isShowEmptyBody={true}
            className="dhx_grid_no_rows_between"
        />
    );
};

//TODO: пересмотреть подход к указанию элементов контекстного меню, возможно через отдельно свойство
const contextMenuItemList = [
    {
        label: 'Удалить',
        icon: <TrashFlatIcon className="text-[#B2C8D4] hover:text-[#99B8C9]" />,
        clickHandler: (row: any, rows: any[], onChange: any) => {
            onChange(rows.filter((item) => item.id !== row.id));
        },
        isOnlyIcon: true
    }
];

const columns: IColumnConfig[] = [
    {
        id: 'state',
        header: [{ text: '' }],
        mark: () => '!pl-0',
        width: 130,
        render: (cellValue: any) => getBadgeCell(cellValue)
    },
    {
        id: '$item',
        header: [{ text: '' }],
        width: 110,
        render: (cellValue: any) => getDefaultCell(cellValue, ' ')
    },
    {
        id: 'name',
        header: [{ text: '' }],
        render: (cellValue: any) => (
            <span className="flex w-full border-r pr-[0.8472vmin]">{getDefaultCell(cellValue)}</span>
        )
    },
    {
        id: 'dateStart',
        header: [{ text: '' }],
        width: 125,
        mark: () => '!pl-0',
        render: (cellValue: any) => (
            <span className="flex w-full border-r pr-[0.8472vmin]">
                {formatTimestamp(cellValue, 'DD.MM.YYYY HH:mm')}
            </span>
        )
    },
    {
        id: 'dateEnd',
        header: [{ text: '' }],
        width: 125,
        mark: () => '!pl-0',
        render: (cellValue: any) => (
            <span className="flex w-full border-r pr-[0.8472vmin]">
                {formatTimestamp(cellValue, 'DD.MM.YYYY HH:mm')}
            </span>
        )
    },
    {
        id: 'executor',
        header: [{ text: '' }],
        width: 140,
        align: 'right',
        render: (cellValue: any) => getDefaultCell(cellValue)
    }
];
